import moment from 'moment';
import Log from '~/types/log';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      log: Log,
      moment: moment,
    },
  };
});
